import { useCallback, useState } from 'react';

import { HealthProviderTranslationsList } from '../../../compositions/health-provider-translations/list/health-provider-translation-list';
import { HealthProviderTranslationModal } from '../../../compositions/health-provider-translations/modals/health-provider-translation-modal/health-provider-translation-modal';
import { useCurrentHealthProvider } from '../../../data/data/health-providers/use-current-health-provider';
import { useHealthProviderTranslationItems } from '../../../data/data/translations/use-health-provider-translations-items';
import { HealthProviderTranslationItemDataFragment } from '../../../data/types/api/graphql';
import { Content } from '../../../elements/content/content';

export function AdminHealthProviderTranslationsPage() {
  const { healthProvider } = useCurrentHealthProvider();

  const [
    healthProviderTranslationModalOpen,
    setHealthProviderTranslationModalOpen,
  ] = useState<HealthProviderTranslationItemDataFragment | false>(false);

  const onHandleHealthProviderTranslation = useCallback(
    (value: HealthProviderTranslationItemDataFragment) => {
      setHealthProviderTranslationModalOpen(value);
    },
    []
  );

  const {
    data: healthProviderTranslationItemsData,
    loading: healthProviderTranslationItemsLoading,
  } = useHealthProviderTranslationItems({
    healthProviderId: healthProvider?.id,
  });

  return (
    <>
      <Content>
        <HealthProviderTranslationsList
          loading={healthProviderTranslationItemsLoading}
          items={healthProviderTranslationItemsData}
          onClick={onHandleHealthProviderTranslation}
        />
      </Content>

      {healthProviderTranslationModalOpen && healthProvider && (
        <HealthProviderTranslationModal
          healthProvider={healthProvider}
          healthProviderTranslationItemData={healthProviderTranslationModalOpen}
          onClose={() => {
            setHealthProviderTranslationModalOpen(false);
          }}
        />
      )}
    </>
  );
}
